<template>
  <div
    :key="uniqueKey" class="rich-wrapper"
    :style="showRichRootStyle">
    <div ref="editable" :style="showRichTextStyle">
    </div>
  </div>
</template>

<script>
import ChartMixin from '@/components/charts/mixin'
import { getFontFamilyCss } from '@/utils/chartTitlePresets'

export default {
  name: 'ShowRich',
  mixins: [ChartMixin],
  props: {
    config: {
      type: Object,
    },
    globalConfig: {
      type: Object,
    },
    componentType: {
      type: String,
    },
    filterParams: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      uniqueKey: 'xxx',
    }
  },
  computed: {
    showRichRootStyle () {
      return {
        width: this.config.chartWidth + 'px',
        height: this.config.chartHeight + 'px',
        fontSize: '22px',
      }
    },
    showRichTextStyle () {
      const t = this.config?.chartSet?.titleStyle
      const ff = getFontFamilyCss(t?.fontFamily)
      return ff ? { fontFamily: ff } : {}
    },
  },
  watch: {
    'config.chartViewData.chartData': {
      handler (val) {
        if (!this.$refs.editable) return
        this.$refs.editable.innerHTML = val == null ? '' : String(val)
      },
    },
  },
  created () {
    this.uniqueKey = Math.random()
  },
  mounted () {
    this.$refs.editable.innerHTML = this.config.chartViewData.chartData || ''
  },
}
</script>

<style lang='scss' scoped>
.rich-wrapper {
  color: #fff;
  overflow: hidden ;
  padding: 5px;
}
</style>
